import * as yup from 'yup';
import {
  contactNameValidation,
  phoneNoValidation,
} from './validationSchemaUtil';
import labels from '../constants/labels';

export const contactUpdateValidationSchema = yup.object().shape({
  userFullName: contactNameValidation(labels.CONTACT_NM),
  phoneNumber: phoneNoValidation(labels.CONTACT_PHNO),
});
